import React, { useState } from 'react';
import Login from './Login';
import Signup from './Signup';

const AuthWrapper: React.FC = () => {
  const [mode, setMode] = useState<'login' | 'signup'>('login');

  const toggleMode = () => {
    setMode(mode === 'login' ? 'signup' : 'login');
  };

  return mode === 'login' ? (
    <Login onToggleMode={toggleMode} />
  ) : (
    <Signup onToggleMode={toggleMode} />
  );
};

export default AuthWrapper;



